export const USER_ROLE = {
  SUPER_ADMIN: 'ROLE_SUPERADMIN',
  ADMIN: 'ROLE_SALESPERSON',
  USER: 'ROLE_USER',
  SELLER: 'ROLE_SALESPERSON'
}
